import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";

const NotFound = lazy(() => import("../../container/pages/404"));
const MembersList = lazy(() => import("../../container/members/MembersList"));
const MemberDetailsTabs = lazy(() =>
  import("../../container/members/DevicesDetailsTabs")
);
const Payments = lazy(() => import("../../container/members/MemberPayments"));
const MemberSubscriptionDetails = lazy(() =>
  import("../../container/members/components/MemberSubscriptionDetails")
);
const AddSubscription = lazy(() =>
  import("../../container/members/components/AddMemberSubscriptionForm")
);
const AddMember = lazy(() =>
  import("../../container/members/components/createMemberForm")
);
const AddPayment = lazy(() =>
  import("../../container/members/components/createPaymentForm")
);

function IconsRoute() {
  return (
    <Routes>
      <Route path="/" element={<MembersList />} />
      <Route path="/add-member" element={<AddMember />} />
      <Route
        path="/:id/subscriptions/:subscriptionId/payments"
        element={<Payments />}
      />
      <Route
        path="/:id/subscriptions/:subscriptionId/edit"
        element={<MemberSubscriptionDetails />}
      />
      <Route
        path="/:id/subscriptions/:subscriptionId/payments/add-payment"
        element={<AddPayment />}
      />
      <Route path="/:id/add-subscription" element={<AddSubscription />} />
      <Route path="/:id/*" element={<MemberDetailsTabs />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default IconsRoute;
